<template>
  <b-modal ref="add-variable-bonus-modal" hide-footer no-close-on-backdrop @hidden="onlyClose" :title="modalTitle">
    <template #default>
      <validation-observer ref="form">
        <b-row>
          <!-- Category -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Category')">
                <b-form-input v-model="form.categoria" v-uppercase :class="{ 'border-danger': errors[0] }"
                  placeholder="e.g. A, B, C, 21+" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Vehicle Type -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Vehicle Type')">
                <b-form-input v-model="form.tipo_vehiculo" v-uppercase :class="{ 'border-danger': errors[0] }"
                  placeholder="e.g. SEMI, CAMION, CC" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Service Type -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Service Type')" :state="errors[0] ? false : null">
                <v-select v-model="form.tipo_servicio" :reduce="(value) => value.label" label="label"
                  :options="serviceTypes" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Service -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Service')">
                <b-form-input v-model="form.servicio" v-uppercase :class="{ 'border-danger': errors[0] }"
                  placeholder="e.g. ASEMILOCAL(0-100KM)" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Destination -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }">
              <b-form-group :label="$t('Destination')">
                <b-form-input v-model="form.destino" v-uppercase :class="{ 'border-danger': errors[0] }"
                  placeholder="e.g. CALLAO, LURIN" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Amount -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Amount')" :state="errors[0] ? false : null">
                <money class="form-control form-control-md" v-model="form.monto" v-bind="amountConfig" />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-2" style="width: 100%">
          <b-button variant="outline-danger" size="sm" @click="onlyClose">
            {{ $t("close") | capitalize }}
          </b-button>
          <b-button variant="outline-primary" class="ml-1" @click="submitForm">
            {{ method == "create" ? $t("save") : $t("edit") | capitalize }}
          </b-button>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import SettingVariableBonusService from "@/views/settings/views/payroll/components/variable-bonus/service/setting-variable-bonus.service.js";
import { mapGetters } from "vuex";

export default {
  props: {
    bonus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    method: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    modalTitle() {
      return this.method === "create"
        ? 'Agregar Bono Variable'
        : 'Editar Bono Variable';
    },
  },
  data() {
    return {
      form: {
        id: null,
        categoria: "",
        tipo_vehiculo: "",
        tipo_servicio: "",
        servicio: "",
        destino: "",
        monto: 0,
      },
      amountConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "S/.",
        precision: 2,
        masked: false,
      },
      serviceTypes: [],
    };
  },
  async mounted() {
    this.toggleModal("add-variable-bonus-modal");
    try {
      this.addPreloader();
      await this.fetchServiceTypes();
      if (this.method === "edit" && this.bonus) {
        this.form = {
          id: this.bonus.id,
          categoria: this.bonus.categoria,
          tipo_vehiculo: this.bonus.tipo_vehiculo,
          tipo_servicio: this.bonus.tipo_servicio,
          servicio: this.bonus.servicio,
          destino: this.bonus.destino || "",
          monto: parseFloat(this.bonus.monto) || 0,
        };
      }
    } catch (error) {
      console.error("Error fetching bonus", error);
      this.showToastError(error?.response?.data?.message || error.message);
    } finally {
      this.removePreloader();
    }
  },
  methods: {
    async fetchServiceTypes() {
      try {
        const data = await SettingVariableBonusService.getServiceTypes();
        this.serviceTypes = data;
      } catch (error) {
        console.error("Error fetching service types", error);
      }
    },
    onlyClose() {
      this.$emit("close");
    },
    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      try {
        this.addPreloader();
        const params = {
          id: this.form.id,
          categoria: this.form.categoria,
          tipo_vehiculo: this.form.tipo_vehiculo,
          tipo_servicio: this.form.tipo_servicio,
          servicio: this.form.servicio,
          destino: this.form.destino,
          monto: this.form.monto,
          user_id: this.currentUser ? this.currentUser.id : null,
        };

        const data = await SettingVariableBonusService.createOrUpdate(params);
        this.showToastSuccess(data.message);
        this.$emit("saved");
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style></style>
